module.exports = __webpack_public_path__ + "static/media/AccountNavIconActive.11bbb9e4.svg";